import axios from 'axios';

export const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/';

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// AUTH
export const loginApi = (email, password) =>
  api.post('adminusers/login', { email, password });

// ADMIN USERS
export const getAdminMeApi = () =>
  api.get('adminusers/me');

export const getAdminsApi = () =>
  api.get('adminusers');

export const createAdminApi = (payload) =>
  api.post('adminusers', payload);

export const updateAdminApi = (id, payload) =>
  api.patch(`adminusers/${id}`, payload);

export const deleteAdminApi = (id) =>
  api.delete(`adminusers/${id}`);

// USERS
export const getUsersApi = (params) =>
  api.get('users', { params });

export const editUserApi = (id, payload) =>
  api.patch(`users/admin/${id}`, payload);

export const deleteUserApi = (id) =>
  api.delete(`users/${id}`);

export const resetPasswordApi = (email) =>
  api.post('users/requestchangepassword', { email });

export const resetSubscriptionApi = (userId) =>
  api.post('users/paid/admin', { userId });

export const getUsersAnalyticsApi = () =>
  api.get('usersanalytics');

export const getUsersAnalyticsTimeseriesApi = (params) =>
  api.get('usersanalytics/timeseries', { params });

// CATEGORIES
export const getCategoriesApi = () =>
  api.get('category?size=300');

export const addCategoryApi = (payload) =>
  api.post('category', payload);

export const editCategoryApi = (id, payload) =>
  api.patch(`category/${id}`, payload);

export const deleteCategoryApi = (id) =>
  api.delete(`category/${id}`);

// SHOWS
export const getShowsApi = () =>
  api.get('show?size=300');

export const addShowApi = (payload) =>
  api.post('show', payload);

export const editShowApi = (id, payload) =>
  api.patch(`show/${id}`, payload);

export const deleteShowApi = (id) =>
  api.delete(`show/${id}`);

// SHOWS V2
export const getShowsV2Api = () =>
  api.get('v2/admin/shows');

export const addShowV2Api = (payload) =>
  api.post('v2/admin/shows', payload);

export const editShowV2Api = (id, payload) =>
  api.patch(`v2/admin/shows/${id}`, payload);

export const deleteShowV2Api = (id) =>
  api.delete(`v2/admin/shows/${id}`);

export const getChannelsV2Api = () =>
  api.get('v2/admin/channels');

// USER LOGS (old)
export const getUserLogsApi = (params) =>
  api.get('v1/userlog', { params });

// REQUEST LOGS
export const getRequestLogsApi = (params) =>
  api.get('v2/requestlogs', { params });

export const getGroupedRequestLogsApi = (params) =>
  api.get('v2/requestlogs/grouped', { params });

export const getUserDeviceLogsApi = (params) =>
  api.get('v2/requestlogs/user-device', { params });

export const deleteRequestLogApi = (id) =>
  api.delete(`v2/requestlogs/${id}`);

export default api;